import LeftSlider from "./components/left-slider";
export default {
  path: "/:type/appdetailV2/*",
  auth: true,
  preload: false,
  key: "appdetailV2",
  layout: "inner", // outer 一级菜单 inner 二级菜单
  leftSlider: LeftSlider,
  component: () => import("./index")
};
